import Main from "@/components/main";

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中，示例看QQ群路由配置
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

export default [
  // 登陆
  {
    path: "/login",
    name: "login",
    meta: {
      title: "Login - 登录",
      hideInMenu: true
    },
    component: () => import("@/view/login/login.vue")
  },
  // 主页
  {
    path: "/",
    name: "_home",
    redirect: "home",
    component: Main,
    meta: {
      hideInMenu: true,
      notCache: true
    },
    children: [
      {
        path: "/home",
        name: "home",
        meta: {
          hideInMenu: true,
          title: "首页",
          notCache: true,
          icon: "md-home"
        },
        component: () => import("@/view/home/home.vue")
      }
    ]
  },
  // 销售
  {
    path: "/sale",
    name: "sale",
    meta: {
      // hideInMenu: true,
      title: "销售",
      // notCache: true,
      icon: "md-home"
    },
    component: Main,
    children: [
      {
        path: "orderlist",
        name: "orderlist",
        meta: {
          
          title: "订单列表"
        },
        component: () => import("@/view/sale/orderlist.vue")
      },
      {
        path: "feedback",
        name: "feedback",
        meta: {
          
          title: "Feedback"
        },
        component: () => import("@/view/sale/feedback.vue")
      },
      {
        path: "listing",
        name: "listing",
        meta: {
          
          title: "Listing"
        },
        component: () => import("@/view/sale/listing.vue")
      },
      {
        path: "listinglog",
        name: "listinglog",
        meta: {
          
          title: "Listinglog"
        },
        component: () => import("@/view/sale/listinglog.vue")
      },
      {
        path: "dispricelog",
        name: "dispricelog",
        meta: {
          
          title: "优惠价日志"
        },
        component: () => import("@/view/sale/dispricelog.vue")
      },
      {
        path: "lxcoupon",
        name: "lxcoupon",
        meta: {
          
          title: "领星促销"
        },
        component: () => import("@/view/sale/lxcoupon.vue")
      },
      {
        path: "buyerreview",
        name: "buyerreview",
        meta: {
          
          title: "买家评论"
        },
        component: () => import("@/view/sale/buyerreview.vue")
      }
    ]
  },
  // 补货
  {
    path: "/buhuo",
    name: "buhuo",
    meta: {
      title: "补货分析",
      icon: "md-home"
    },
    component: Main,
    children: [
      {
        path: "cprd",
        name: "cprd",
        meta: {
          
          title: "补货分析"
        },
        component: () => import("@/view/buhuo/cprd.vue")
      },
      {
        path: "cprdspu",
        name: "cprdspu",
        meta: {
          
          title: "父体分析"
        },
        component: () => import("@/view/buhuo/cprdspu.vue")
      },
      {
        path: "skuprofit",
        name: "skuprofit",
        meta: {
          
          title: "产品周期横比"
        },
        component: () => import("@/view/buhuo/skuprofit.vue")
      },
      {
        path: "spumonth",
        name: "spumonth",
        meta: {
          
          title: "父体数量月统计"
        },
        component: () => import("@/view/buhuo/spunum.vue")
      }
    ]
  },
  // FBA
  {
    path: "/fba",
    name: "fba",
    meta: {
      title: "FBA",
      icon: "md-home"
    },
    component: Main,
    children: [
      {
        path: "deliveryplan",
        name: "deliveryplan",
        meta: {
          
          title: "发货计划"
        },
        component: () => import("@/view/fba/deliveryplan/index.vue")
      },
      {
        path: "deliveryplansupplier",
        name: "deliveryplansupplier",
        meta: {
          
          title: "供应商发货计划"
        },
        component: () => import("@/view/fba/deliveryplansupplier/index.vue")
      },
      {
        path: "fbabox",
        name: "fbabox",
        meta: {
          
          title: "FBA装箱单"
        },
        component: () => import("@/view/fba/fbabox/index.vue")
      },
      {
        path: "shiplist",
        name: "shiplist",
        meta: {
          
          title: "FBA货件"
        },
        component: () => import("@/view/fba/shiplist/index.vue")
      },
      {
        path: "shipdownload",
        name: "shipdownload",
        meta: {
          
          title: "发货单下载"
        },
        component: () => import("@/view/fba/shipdownload/index.vue")
      },
      {
        path: "shippingaddress",
        name: "shippingaddress",
        meta: {
          
          title: "发货地址"
        },
        component: () => import("@/view/fba/shippingaddress/index.vue")
      },
      {
        path: "receiveaddress",
        name: "receiveaddress",
        meta: {
          
          title: "收货地址"
        },
        component: () => import("@/view/fba/receiveaddress/index.vue")
      },
      {
        path: "declaration",
        name: "declaration",
        meta: {
          
          title: "申报分类"
        },
        component: () => import("@/view/fba/declaration/index.vue")
      },
      {
        path: "stockgross",
        name: "stockgross",
        meta: {
          
          title: "库存总值"
        },
        component: () => import("@/view/fba/stockgross/index.vue")
      }
    ]
  },
  // 商品
  {
    path: "/product",
    name: "product",
    meta: {
      icon: "logo-buffer",
      title: "商品"
    },
    component: Main,
    children: [
      {
        path: "notice",
        name: "notice",
        meta: {
          
          title: "通知"
        },
        component: () => import("@/view/product/notice.vue")
      },
      {
        path: "mailproduct",
        name: "mailproduct",
        meta: {
          
          title: "邮件商品重新测量"
        },
        component: () => import("@/view/product/mailproduct.vue")
      },
      {
        path: "productlist",
        name: "productlist",
        meta: {
          
          title: "商品列表"
        },
        component: () => import("@/view/product/productlist.vue")
      },
      {
        path: "selectstyle",
        name: "selectstyle",
        meta: {
          
          title: "选品结构"
        },
        component: () => import("@/view/product/selectstyle.vue")
      },
      {
        path: "theme",
        name: "theme",
        meta: {
          
          title: "主题管理"
        },
        component: () => import("@/view/product/theme.vue")
      },
      {
        path: "type",
        name: "type",
        meta: {
          
          title: "商品分类"
        },
        component: () => import("@/view/product/type.vue")
      },
      {
        path: "historyfxrate",
        name: "historyfxrate",
        meta: {
          
          title: "历史汇率"
        },
        component: () => import("@/view/product/historyfxrate.vue")
      },
      {
        path: "brand",
        name: "brand",
        meta: {
          
          title: "商品品牌"
        },
        component: () => import("@/view/product/brand.vue")
      },
      {
        path: "productprice",
        name: "productprice",
        meta: {
          
          title: "成本计算"
        },
        component: () => import("@/view/product/productprice.vue")
      },
      {
        path: "productpriceother",
        name: "productpriceother",
        meta: {
          
          title: "其他平台成本计算"
        },
        component: () => import("@/view/product/productpriceother.vue")
      },
      {
        path: "partlist",
        name: "partlist",
        meta: {
          
          title: "配件列表"
        },
        component: () => import("@/view/product/partlist.vue")
      },
      {
        path: "parttype",
        name: "parttype",
        meta: {
          
          title: "配件分类"
        },
        component: () => import("@/view/product/parttype.vue")
      },
      {
        path: "historyprice",
        name: "historyprice",
        meta: {
          
          title: "价格跟踪"
        },
        component: () => import("@/view/product/historyprice.vue")
      },
      {
        path: "sucai",
        name: "sucai",
        meta: {
          
          title: "素材管理"
        },
        component: () => import("@/view/product/sucai.vue")
      }
    ]
  },
  // 采购
  {
    path: "/purchase",
    name: "purchase",
    meta: {
      icon: "logo-buffer",
      title: "采购"
    },
    component: Main,
    children: [
      {
        path: "supplierinware",
        name: "supplierinware",
        meta: {
          
          title: "供应商入库汇总"
        },
        component: () => import("@/view/purchase/supplierinware.vue")
      },
      {
        path: "production",
        name: "production",
        meta: {
          
          title: "生产记录"
        },
        component: () => import("@/view/purchase/production/index.vue")
      },
      {
        path: "productionprint",
        name: "productionprint",
        meta: {
          
          title: "纺织品标签打印"
        },
        component: () => import("@/view/purchase/productionprint.vue")
      },
      {
        path: "supplier",
        name: "supplier",
        meta: {
          
          title: "供应商管理"
        },
        component: () => import("@/view/purchase/supplier.vue")
      },
      {
        path: "order",
        name: "order",
        meta: {
          
          title: "采购单"
        },
        component: () => import("@/view/purchase/order.vue")
      },
      {
        path: "purchase_plan",
        name: "purchase_plan",
        meta: {
          
          title: "采购计划"
        },
        component: () => import("@/view/purchase/order.vue")
      },
      {
        path: "purchased",
        name: "purchased",
        meta: {
          
          title: "已采购"
        },
        component: () => import("@/view/purchase/order.vue")
      },
      {
        path: "warehoused",
        name: "warehoused",
        meta: {
          
          title: "已入仓"
        },
        component: () => import("@/view/purchase/order.vue")
      },
      {
        path: "factoryorder",
        name: "factoryorder",
        meta: {
          
          title: "工厂单"
        },
        component: () => import("@/view/purchase/factoryorder.vue")
      },
      {
        path: "change",
        name: "change",
        meta: {
          
          title: "采购变更单"
        },
        component: () => import("@/view/purchase/change.vue")
      },
      {
        path: "purchasecost",
        name: "purchasecost",
        meta: {
          
          title: "采购费用"
        },
        component: () => import("@/view/purchase/purchasecost.vue")
      },
      {
        path: "purchasedetail",
        name: "purchasedetail",
        meta: {
          
          title: "取货明细"
        },
        component: () => import("@/view/purchase/purchasedetail.vue")
      },
      {
        path: "fbapurchasedetail",
        name: "fbapurchasedetail",
        meta: {
          
          title: "FBA取货明细"
        },
        component: () => import("@/view/purchase/fbapurchasedetail/index.vue")
      },
      {
        path: "purchasesettle",
        name: "purchasesettle",
        meta: {
          
          title: "对账结算"
        },
        component: () => import("@/view/purchase/purchasesettle.vue")
      },
      {
        path: "deliveryform",
        name: "deliveryform",
        meta: {
          
          title: "发货单"
        },
        component: () => import("@/view/purchase/deliveryform.vue")
      },
      {
        path: "warehouselist",
        name: "warehouselist",
        meta: {
          
          title: "仓库管理"
        },
        component: () => import("@/view/purchase/warehouselist.vue")
      },
      {
        path: "otherwarehouse",
        name: "otherwarehouse",
        meta: {
          
          title: "新平台仓库"
        },
        component: () => import("@/view/purchase/otherwarehouse/index.vue")
      }
    ]
  },
  // 其他平台
  {
    path: "/otherplat",
    name: "otherplat",
    meta: {
      icon: "logo-buffer",
      title: "其他平台"
    },
    component: Main,
    children: [
      {
        path: "pddaccountsum",
        name: "pddaccountsum",
        meta: {
          title: "半托账户透视"
        },
        component: () => import("@/view/otherplat/pddaccountsum.vue")
      },
      {
        path: "pddad",
        name: "pddad",
        meta: {
          
          title: "拼多多广告导入展示"
        },
        component: () => import("@/view/otherplat/pddad.vue")
      },
      {
        path: "pddcampaign",
        name: "pddcampaign",
        meta: {
          
          title: "拼多多活动"
        },
        component: () => import("@/view/otherplat/pddcampaign.vue")
      },
      {
        path: "otherproduct",
        name: "otherproduct",
        meta: {
          
          title: "其他平台商品"
        },
        component: () => import("@/view/otherplat/productlist.vue")
      },
      {
        path: "orderprofit",
        name: "orderprofit",
        meta: {
          
          title: "拼多多付款表分析-订单"
        },
        component: () => import("@/view/otherplat/orderprofit.vue")
      },
      {
        path: "pddproductprofit",
        name: "pddproductprofit",
        meta: {
          
          title: "拼多多付款表分析-产品利润"
        },
        component: () => import("@/view/otherplat/productprofit.vue")
      },
      {
        path: "orderpdf",
        name: "orderpdf",
        meta: {
          
          title: "订单标签"
        },
        component: () => import("@/view/otherplat/orderpdf.vue")
      },
      {
        path: "platlist",
        name: "platlist",
        meta: {
          
          title: "平台管理"
        },
        component: () => import("@/view/otherplat/platlist.vue")
      },
      {
        path: "othershipplan",
        name: "othershipplan",
        meta: {
          
          title: "拼多多发货计划"
        },
        component: () => import("@/view/otherplat/shipplan.vue")
      },
      {
        path: "otheronway",
        name: "otheronway",
        meta: {
          
          title: "在途"
        },
        component: () => import("@/view/otherplat/shipplan.vue")
      },
      {
        path: "othertoucheng",
        name: "othertoucheng",
        meta: {
          
          title: "头程"
        },
        component: () => import("@/view/otherplat/shipplan.vue")
      },
      {
        path: "otherwarehoused",
        name: "otherwarehoused",
        meta: {
          
          title: "海外仓"
        },
        component: () => import("@/view/otherplat/shipplan.vue")
      },
      {
        path: "othersaled",
        name: "othersaled",
        meta: {
          
          title: "售出"
        },
        component: () => import("@/view/otherplat/shipplan.vue")
      },
      {
        path: "shiptemp",
        name: "shiptemp",
        meta: {
          
          title: "发货模板生成"
        },
        component: () => import("@/view/otherplat/shiptemp.vue")
      },
	  ]
  },
  // 发货
  {
    path: "/warehouse",
    name: "warehouse",
    meta: {
      icon: "logo-buffer",
      title: "发货"
    },
    component: Main,
    children: [
      {
        path: "supplierstock",
        name: "supplierstock",
        meta: {
          
          title: "供应商库存"
        },
        component: () => import("@/view/warehouse/supplierstock/index.vue")
      },
      {
        path: "expresstype",
        name: "expresstype",
        meta: {
          
          title: "快递方式"
        },
        component: () => import("@/view/warehouse/expresstype.vue")
      },
      {
        path: "expressagent",
        name: "expressagent",
        meta: {
          
          title: "快递代理商"
        },
        component: () => import("@/view/warehouse/expressagent.vue")
      },
      {
        path: "head",
        name: "head",
        meta: {
          
          title: "头程"
        },
        component: () => import("@/view/warehouse/head.vue")
      },
      {
        path: "goods",
        name: "goods",
        meta: {
          
          title: "入库"
        },
        component: () => import("@/view/warehouse/goods.vue")
      },
      {
        path: "fahuo",
        name: "fahuo",
        meta: {
          
          title: "FBA发货"
        },
        component: () => import("@/view/warehouse/fahuo.vue")
      },
      {
        path: "otherfahuo",
        name: "otherfahuo",
        meta: {
          
          title: "其他发货"
        },
        component: () => import("@/view/warehouse/otherfahuo.vue")
      },
      {
        path: "caiwufahuo",
        name: "caiwufahuo",
        meta: {
          
          title: "发货-财务对账"
        },
        component: () => import("@/view/warehouse/caiwufahuo.vue")
      },
      {
        path: "tongjiexpress",
        name: "tongjiexpress",
        meta: {
          
          title: "发货统计"
        },
        component: () => import("@/view/warehouse/tongjiexpress.vue")
      },
      {
        path: "header",
        name: "header",
        meta: {
          
          title: "新头程"
        },
        component: () => import("@/view/warehouse/header/index.vue")
      }
    ]
  },
  // 广告
  {
    path: "/ad",
    name: "ad",
    meta: {
      icon: "logo-buffer",
      title: "广告"
    },
    component: Main,
    children: [
      {
        path: "camhour",
        name: "camhour",
        meta: {
          
          title: "广告活动分时"
        },
        component: () => import("@/view/ad/camhour.vue")
      },
      {
        path: "camhourview",
        name: "camhourview",
        meta: {
          
          title: "广告活动分时透视"
        },
        component: () => import("@/view/ad/camhourview.vue")
      },
      {
        path: "sbmanage",
        name: "sbmanage",
        meta: {
          
          title: "sb广告报告"
        },
        component: () => import("@/view/ad/sbmanage.vue")
      },
      {
        path: "sdmanage",
        name: "sdmanage",
        meta: {
          
          title: "sd广告报告"
        },
        component: () => import("@/view/ad/sdmanage.vue")
      },
      {
        path: "spmanage",
        name: "spmanage",
        meta: {
          
          title: "sp广告"
        },
        component: () => import("@/view/ad/spmanage.vue")
      },
      {
        path: "adsb",
        name: "adsb",
        meta: {
          
          title: "sb广告"
        },
        component: () => import("@/view/adsb/adsb.vue")
      },
      {
        path: "adsd",
        name: "adsd",
        meta: {
          
          title: "sd广告"
        },
        component: () => import("@/view/adsd/adsd.vue")
      },
      {
        path: "skukeyword",
        name: "skukeyword",
        meta: {
          
          title: "sku关键词"
        },
        component: () => import("@/view/ad/skukeyword.vue")
      },
      {
        path: "keyword",
        name: "keyword",
        meta: {
          
          title: "关键词库"
        },
        component: () => import("@/view/ad/keyword.vue")
      },
      {
        path: "productkeyword",
        name: "productkeyword",
        meta: {
          
          title: "产品关键词"
        },
        component: () => import("@/view/ad/productkeyword.vue")
      },
      {
        path: "comp",
        name: "comp",
        meta: {
          
          title: "竞争对手"
        },
        component: () => import("@/view/ad/comp.vue")
      },
      {
        path: "sku",
        name: "sku",
        meta: {
          
          title: "广告统计"
        },
        component: () => import("@/view/tongji/ad.vue")
      },
      {
        path: "remark",
        name: "remark",
        meta: {
          
          title: "广告备注"
        },
        component: () => import("@/view/ad/remark.vue")
      },
    ]
  },
  // 统计
  {
    path: "/tongji",
    name: "tongji",
    meta: {
      icon: "logo-buffer",
      title: "统计"
    },
    component: Main,
    children: [
      {
        path: "productshortage",
        name: "productshortage",
        meta: {
          
          title: "断货追踪"
        },
        component: () => import("@/view/tongji/productshortage.vue")
      },
      {
        path: "productdestroy",
        name: "productdestroy",
        meta: {
          
          title: "弃置详情"
        },
        component: () => import("@/view/tongji/productdestroy.vue")
      },
      {
        path: "searchbrandview",
        name: "searchbrandview",
        meta: {
          
          title: "搜索词品牌视图"
        },
        component: () => import("@/view/tongji/searchbrandview.vue")
      },
      {
        path: "searchbrandviewtag",
        name: "searchbrandviewtag",
        meta: {
          
          title: "搜索词品牌视图属性"
        },
        component: () => import("@/view/tongji/searchbrandviewtag.vue")
      },
      {
        path: "pickup",
        name: "pickup",
        meta: {
          
          title: "拣货单"
        },
        component: () => import("@/view/tongji/pddpickup.vue")
      },
      {
        path: "expresstotal",
        name: "expresstotal",
        meta: {
          
          title: "运输方式透视"
        },
        component: () => import("@/view/warehouse/expresstotal.vue")
      },
      {
        path: "designprofit",
        name: "designprofit",
        meta: {
          
          title: "设计透视"
        },
        component: () => import("@/view/tongji/designprofit.vue")
      },
      {
        path: "pddstockgross",
        name: "pddstockgross",
        meta: {
          
          title: "拼多多库存总值"
        },
        component: () => import("@/view/tongji/pddstockgross.vue")
      },
      {
        path: "asinqueryreport",
        name: "asinqueryreport",
        meta: {
          
          title: "ASIN自然搜索词"
        },
        component: () => import("@/view/tongji/asinqueryreport.vue")
      },
      {
        path: "asinadqueryreport",
        name: "asinadqueryreport",
        meta: {
          
          title: "ASIN广告搜索词"
        },
        component: () => import("@/view/tongji/asinadqueryreport.vue")
      },
      {
        path: "asinquerysum",
        name: "asinquerysum",
        meta: {
          
          title: "ASIN搜索词总计"
        },
        component: () => import("@/view/tongji/asinquerysum.vue")
      },
      {
        path: "skureport",
        name: "skureport",
        meta: {
          
          title: "业务报表-手动导入"
        },
        component: () => import("@/view/tongji/skureport.vue")
      },
      {
        path: "skureportamz",
        name: "skureportamz",
        meta: {
          
          title: "业务报表-自动拉取"
        },
        component: () => import("@/view/tongji/skureportamz.vue")
      },
      {
        path: "salesrate",
        name: "salesrate",
        meta: {
          
          title: "账户数据日统计"
        },
        component: () => import("@/view/tongji/salesrate.vue")
      },
      {
        path: "sales",
        name: "sales",
        meta: {
          
          title: "销量统计"
        },
        component: () => import("@/view/tongji/sales.vue")
      },
      {
        path: "pddsales",
        name: "pddsales",
        meta: {
          
          title: "拼多多销量统计"
        },
        component: () => import("@/view/tongji/pddsales.vue")
      },
      {
        path: "pddorderlist",
        name: "pddorderlist",
        meta: {
          
          title: "抓取-拼多多订单"
        },
        component: () => import("@/view/tongji/pddorderlist.vue")
      },
      {
        path: "returnorder",
        name: "returnorder",
        meta: {
          
          title: "抓取-拼多多退货"
        },
        component: () => import("@/view/tongji/returnorder.vue")
      },
      {
        path: "shipbill",
        name: "shipbill",
        meta: {
          
          title: "抓取-发货面单"
        },
        component: () => import("@/view/tongji/shipbill.vue")
      },
      {
        path: "pddstock",
        name: "pddstock",
        meta: {
          
          title: "拼多多备货单"
        },
        component: () => import("@/view/tongji/pddstock.vue")
      },
      {
        path: "cprdpdd",
        name: "cprdpdd",
        meta: {
          
          title: "拼多多补货分析"
        },
        component: () => import("@/view/buhuopdd/cprd.vue")
      },
      {
        path: "cprdpddskusum",
        name: "cprdpddskusum",
        meta: {
          
          title: "SKU汇总补货分析"
        },
        component: () => import("@/view/buhuopdd/cprdskusum.vue")
      },
      {
        path: "cprdpddspu",
        name: "cprdpddspu",
        meta: {
          
          title: "父体补货分析"
        },
        component: () => import("@/view/buhuopdd/cprdspu.vue")
      },
      {
        path: "pddprofit",
        name: "pddprofit",
        meta: {
          
          title: "拼多多产品利润-全托"
        },
        component: () => import("@/view/tongji/pddprofit.vue")
      },
      {
        path: "pddprofitbt",
        name: "pddprofitbt",
        meta: {
          
          title: "拼多多产品利润-半托"
        },
        component: () => import("@/view/tongji/pddprofitbt.vue")
      },
      {
        path: "pddaccountprofit",
        name: "pddaccountprofit",
        meta: {
          
          title: "拼多多账户利润"
        },
        component: () => import("@/view/tongji/pddaccountprofit.vue")
      },
      {
        path: "pddsalesxl",
        name: "pddsalesxl",
        meta: {
          
          title: "销量统计"
        },
        component: () => import("@/view/tongji/pddsalesxl.vue")
      },
      {
        path: "pddsalesxp",
        name: "pddsalesxp",
        meta: {
          
          title: "其他平台选品统计"
        },
        component: () => import("@/view/tongji/pddsalesxp.vue")
      },
      {
        path: "selectionsales",
        name: "selectionsales",
        meta: {
          
          title: "选品统计"
        },
        component: () => import("@/view/tongji/selectionsales.vue")
      },
      {
        path: "back",
        name: "back",
        meta: {
          
          title: "退货统计"
        },
        component: () => import("@/view/tongji/back.vue")
      },
      {
        path: "stockremove",
        name: "stockremove",
        meta: {
          
          title: "移仓统计"
        },
        component: () => import("@/view/tongji/stockremove.vue")
      },
      {
        path: "storefee",
        name: "storefee",
        meta: {
          
          title: "月仓储费"
        },
        component: () => import("@/view/tongji/storefee.vue")
      },
      {
        path: "cpbx",
        name: "cpbx",
        meta: {
          
          title: "产品表现"
        },
        component: () => import("@/view/tongji/cpbx.vue")
      },
      {
        path: "pay",
        name: "pay",
        meta: {
          
          title: "付款分析"
        },
        component: () => import("@/view/tongji/pay.vue")
      },
      {
        path: "profit",
        name: "profit",
        meta: {
          
          title: "产品利润分析"
        },
        component: () => import("@/view/tongji/profit.vue")
      },
      {
        path: "profitad",
        name: "profitad",
        meta: {
          
          title: "节点产品利润分析"
        },
        component: () => import("@/view/tongji/profitad.vue")
      },
      {
        path: "accountprofitmonth",
        name: "accountprofitmonth",
        meta: {
          
          title: "结算表-月统计"
        },
        component: () => import("@/view/tongji/accountprofitmonth.vue")
      },
      {
        path: "accountprofit3month",
        name: "accountprofit3month",
        meta: {
          
          title: "利润3期横比"
        },
        component: () => import("@/view/tongji/accountprofit3month.vue")
      },
      {
        path: "accountprofit",
        name: "accountprofit",
        meta: {
          
          title: "账户利润分析"
        },
        component: () => import("@/view/tongji/accountprofit.vue")
      },
      {
        path: "accountprofitsum",
        name: "accountprofitsum",
        meta: {
          
          title: "账户利润透视"
        },
        component: () => import("@/view/tongji/accountprofitsum.vue")
      },
      {
        path: "yyproductprofit",
        name: "yyproductprofit",
        meta: {
          
          title: "运营产品利润"
        },
        component: () => import("@/view/tongji/profit_user.vue")
      },
      {
        path: "xpproductprofit",
        name: "xpproductprofit",
        meta: {
          
          title: "选品产品利润"
        },
        component: () => import("@/view/tongji/profit_user.vue")
      },
      {
        path: "sjproductprofit",
        name: "sjproductprofit",
        meta: {
          
          title: "设计师产品利润"
        },
        component: () => import("@/view/tongji/profit_user.vue")
      },
      {
        path: "week",
        name: "week",
        meta: {
          
          title: "周变化表"
        },
        component: () => import("@/view/tongji/week.vue")
      },
      {
        path: "reward",
        name: "reward",
        meta: {
          
          title: "奖金"
        },
        component: () => import("@/view/tongji/reward.vue")
      },
      {
        path: "qizhi",
        name: "qizhi",
        meta: {
          
          title: "弃置表格"
        },
        component: () => import("@/view/tongji/qizhi.vue")
      },
      {
        path: "storesum",
        name: "storesum",
        meta: {
          
          title: "账户统计"
        },
        component: () => import("@/view/tongji/storesum.vue")
      },
      {
        path: "adlog",
        name: "adlog",
        meta: {
          
          title: "透视广告"
        },
        component: () => import("@/view/tongji/adlog.vue")
      },
      {
        path: "listingchangelog",
        name: "listingchangelog",
        meta: {
          
          title: "透视listing"
        },
        component: () => import("@/view/tongji/listingchangelog.vue")
      },
      {
        path: "fzpmakelog",
        name: "fzpmakelog",
        meta: {
          
          title: "透视生产"
        },
        component: () => import("@/view/tongji/fzpmakelog.vue")
      }
    ]
  },
  // 记录
  {
    path: "/record",
    name: "record",
    meta: {
      icon: "logo-buffer",
      title: "记录"
    },
    component: Main,
    children: [
      {
        path: "issues",
        name: "issues",
        meta: {
          
          title: "工作失误记录"
        },
        component: () => import("@/view/record/issues.vue")
      },
      {
        path: "copyright",
        name: "copyright",
        meta: {
          
          title: "版权"
        },
        component: () => import("@/view/record/copyright.vue")
      },
      {
        path: "cert",
        name: "cert",
        meta: {
          
          title: "授权书"
        },
        component: () => import("@/view/record/copyright.vue")
      },
      {
        path: "grablog",
        name: "grablog",
        meta: {
          
          title: "历史抓取记录"
        },
        component: () => import("@/view/record/grablog/index.vue")
      },
      {
        path: "localimglog",
        name: "localimglog",
        meta: {
          
          title: "本地图片同步"
        },
        component: () => import("@/view/record/localimglog/index.vue")
      },
      {
        path: "uploadimglog",
        name: "uploadimglog",
        meta: {
          
          title: "图片上传日志"
        },
        component: () => import("@/view/record/uploadimglog/index.vue")
      },
      {
        path: "invoice",
        name: "invoice",
        meta: {
          
          title: "报关开票"
        },
        component: () => import("@/view/record/invoice.vue")
      },
      {
        path: "bill",
        name: "bill",
        meta: {
          
          title: "公司账单"
        },
        component: () => import("@/view/record/bill.vue")
      },
      {
        path: "deal",
        name: "deal",
        meta: {
          
          title: "deal记录"
        },
        component: () => import("@/view/record/deal.vue")
      },
      {
        path: "designtask",
        name: "designtask",
        meta: {
          
          title: "美工任务"
        },
        component: () => import("@/view/record/designtask.vue")
      },
      {
        path: "selection",
        name: "selection",
        meta: {
          
          title: "纺织品选品"
        },
        component: () => import("@/view/record/selection.vue")
      },
      {
        path: "selectionslt",
        name: "selectionslt",
        meta: {
          
          title: "其他选品"
        },
        component: () => import("@/view/record/selectionslt.vue")
      },
      {
        path: "steal",
        name: "steal",
        meta: {
          
          title: "抄袭记录"
        },
        component: () => import("@/view/record/steal.vue")
      },
      {
        path: "productupdate",
        name: "productupdate",
        meta: {
          
          title: "事件提醒"
        },
        component: () => import("@/view/record/productupdate.vue")
      },
    {
      path: "travelapply",
      name: "travelapply",
      meta: {
        icon: "md-arrow-dropdown-circle",
        title: "出差申请"
      },
      component: () => import("@/view/record/travelapply.vue")
    }
    ]
  },
  // 设置
  {
    path: "/auth",
    name: "auth",
    meta: {
      icon: "logo-buffer",
      title: "设置"
    },
    component: Main,
    children: [
      {
        path: "admin",
        name: "admin",
        meta: {
          
          title: "管理员管理"
        },
        component: () => import("@/view/auth/admin.vue")
      },
      {
        path: "adminlog",
        name: "adminlog",
        meta: {
          
          title: "操作日志"
        },
        component: () => import("@/view/auth/adminlog.vue")
      },
      {
        path: "group",
        name: "group",
        meta: {
          
          title: "角色组"
        },
        component: () => import("@/view/auth/group.vue")
      },
      {
        path: "storemanage",
        name: "storemanage",
        meta: {
          
          title: "店铺管理"
        },
        component: () => import("@/view/auth/storemanage.vue")
      },
      {
        path: "profile",
        name: "profile",
        meta: {
          
          title: "个人信息"
        },
        component: () => import("@/view/auth/profile.vue")
      }
    ]
  },
  // 客服
  {
    path: "/problem",
    name: "problem",
    meta: {
      icon: "logo-buffer",
      title: "客服"
    },
    component: Main,
    children: [
      {
        path: "zhuanli",
        name: "zhuanli",
        meta: {
          
          title: "水龙头专利管理"
        },
        component: () => import("@/view/problem/zhuanli.vue")
      },
      {
        path: "qinquan",
        name: "qinquan",
        meta: {
          
          title: "水龙头侵权管理"
        },
        component: () => import("@/view/problem/qinquan.vue")
      },
      {
        path: "mailmessage",
        name: "mailmessage",
        meta: {
          
          title: "邮件消息"
        },
        component: () => import("@/view/problem/mailmessage/Index.vue")
      },
      {
        path: "customer",
        name: "customer",
        meta: {
          
          title: "订单问题"
        },
        component: () => import("@/view/problem/customer.vue")
      },
      {
        path: "customersupplier",
        name: "customersupplier",
        meta: {
          
          title: "订单问题-供应商"
        },
        component: () => import("@/view/problem/customersupplier.vue")
      },
      {
        path: "problemtype",
        name: "problemtype",
        meta: {
          
          title: "问题类型"
        },
        component: () => import("@/view/problem/problemtype.vue")
      },
      {
        path: "problembom",
        name: "problembom",
        meta: {
          
          title: "问题部件"
        },
        component: () => import("@/view/problem/problembom.vue")
      },
      {
        path: "mailmanage",
        name: "mailmanage",
        meta: {
          
          title: "站内信"
        },
        component: () => import("@/view/problem/mailmanage/index.vue")
      },
      {
        path: "mailtemplate",
        name: "mailtemplate",
        meta: {
          
          title: "站内信模板管理"
        },
        component: () => import("@/view/problem/mailtemplate/index.vue")
      },
      {
        path: "template",
        name: "template",
        meta: {
          
          title: "邮件模板"
        },
        component: () => import("@/view/problem/template/index.vue")
      },
      {
        path: "payfor",
        name: "payfor",
        meta: {
          
          title: "赔偿模块"
        },
        component: () => import("@/view/problem/payfor.vue")
      }
    ]
  },
  // OA
  {
    path: "/oa",
    name: "oa",
    meta: {
      title: "OA"
    },
    component: Main,
    children: [
      {
        path: "oatask",
        name: "oatask",
        meta: {
          title: "oa任务"
        },
        component: () => import("@/view/oa/oatask.vue")
      },
	  ]
  },
  // error 401
  {
    path: "/401",
    name: "error_401",
    meta: {
      hideInMenu: true
    },
    component: () => import("@/view/error-page/401.vue")
  },
  // error 500
  {
    path: "/500",
    name: "error_500",
    meta: {
      hideInMenu: true
    },
    component: () => import("@/view/error-page/500.vue")
  },
  // error 404
  {
    path: "*",
    name: "error_404",
    meta: {
      hideInMenu: true
    },
    component: () => import("@/view/error-page/404.vue")
  }
];



// WEBPACK FOOTER //
// ./src/router/routers.js